import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { ToasterService } from "angular2-toaster";
import { CommonService } from "../../../common/commonService";
import { Location } from "@angular/common";
import { urlConstant } from "../../../constant/urlConstant";
import { ImageShowModalComponent } from "../../../shared/image-slider/image-show-modal/image-show-modal.component";

@Component({
  selector: "app-proforma-invoice-receipt",
  templateUrl: "./proforma-invoice-receipt.component.html",
  styleUrls: ["./proforma-invoice-receipt.component.scss"],
})
export class ProformaInvoiceReceiptComponent implements OnInit {
  propertyId: any;
  receiptType: any;
  invoiceId: any;
  section: any;
  recepintList: any[] = [];
  billTypeList: any[] = [];
  invoice: any = {};
  bankSavedData: any = {};
  company: any = {};
  selectedRecepint = new FormControl("");
  userDetail: any = {};
  itemNotes = new FormControl("");
  subTotal: number = 0;
  cPercentage = new FormControl("");
  sPercentage = new FormControl("");
  dPercentage = new FormControl("");
  totalCgstAmount: number = 0;
  totalSgstAmount: number = 0;
  totalDiscountAmount: number = 0;
  grandSubTotal: number = 0;
  loginUserDetail: any;
  openUrlId: any;
  propertyData: any = {};
  invoiceForm: FormGroup;
  companySignature: any;
  openView: boolean = false;
  sahredUserDetail: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _CommonService: CommonService,
    private toatserService: ToasterService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private location: Location,
    public sanitizer: DomSanitizer
  ) {
    this.createForm();
    if (this.location.path().includes("action") === true) {
      this.openView = true;
      this.openUrlId = this.route.snapshot.params.id;
      this._CommonService.showLoading();
      this.getInvoiceOpenUrl();
    } else {
      this.propertyId = this.route.snapshot.params.id.split("_")[0];
      this.invoiceId = this.route.snapshot.params.id.split("_")[2];
      if (this.invoiceId !== undefined && this.invoiceId !== null) {
        this.getParamMaster();
        this.getInvoiceByInvoiceId(this.invoiceId);
      }
      if (this.route.snapshot.params.id.split("_")[3] !== undefined) {
        this.section = this.route.snapshot.params.id.split("_")[3];
      }
    }
  }
  getInvoiceOpenUrl() {
    this._CommonService
      .get<any>(
        urlConstant.ProformaInvoice.getProformaInvoiceOpenUrl +
          "?sharedId=" +
          this.openUrlId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          console.log(res.data);
          if (!!res.data.InvoiceOpenUrl) {
            this.getInvoiceByInvoiceId(
              res.data.InvoiceOpenUrl.proformaInvoiceId
            );
          }
          // this.invoice = res.data.Invoice;
          this.propertyData = res.data.Property;
          // this.company = res.data.CompanyDetail;
          // this.sahredUserDetail = res.data.SharedBy;
          // this.getBillTo(res.data.Invoice);
          // this.patchValuesToDescription(this.invoice);
          this.receiptType = "rec";
        } else {
          this.toatserService.pop("error", "Error", res.message);
        }
      });
  }

  getBillTo(invoice: any) {
    this.selectedRecepint.setValue(invoice.selecteReceipnt);
    invoice.userList.map((ele: any) => {
      if (
        String(ele.roleName).toLowerCase() ===
        String(invoice.selecteReceipnt).toLowerCase()
      ) {
        this.userDetail = ele;
      }
    });
    this.bankSavedData = invoice.bankInfo;
  }

  createForm() {
    this.invoiceForm = this.formBuilder.group({
      invoice: this.formBuilder.array([
        new FormGroup({
          hsnSsc: new FormControl(""),
          itemType: new FormControl(""),
          itemName: new FormControl(""),
          itemDescription: new FormControl(""),
          unitAmount: new FormControl(""),
          quantity: new FormControl(1),
          totalAmount: new FormControl(""),
          showInvoiceSave: new FormControl(false),
          showDropDown: new FormControl(false),
          identityId: new FormControl(null),
          invoiceDetailId: new FormControl(null),
        }),
      ]),
    });
    this.fields.removeAt(0);
  }

  get fields(): FormArray {
    return this.invoiceForm.get("invoice") as FormArray;
  }

  getParamMaster() {
    this._CommonService
      .get<any>(urlConstant.ProformaInvoice.getParamMasterForProformaInvoice)
      .subscribe((res: any) => {
        this.recepintList = res.data.recepintList;
        this.billTypeList = res.data.billTypeList;
      });
  }
  getInvoiceByInvoiceId(invoiceId: any) {
    this._CommonService
      .get<any>(
        urlConstant.ProformaInvoice.getProformaInvoiceByInvoiceId +
          "?proformainvoiceId=" +
          invoiceId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.invoice = res.data.Invoice;
          this.bankSavedData = this.invoice.bankInfo;
          this.company = res.data.Company;
          this.selectedRecepint.setValue(this.invoice.selecteReceipnt);
          this.onChangeRecepint();
          this.patchValuesToDescription(this.invoice);
          this.getCompanyDetails();
        }
      });
  }

  ngOnInit() {
    this.loginUserDetail = this._CommonService.getLoggedInUser();
    if (
      !!this.loginUserDetail &&
      (this.openUrlId === null || this.openUrlId === undefined)
    ) {
      this.getPropertyByPropertyId();
    }
    console.log("cccc", this.company);
  }

  onChangeRecepint() {
    this.invoice.userList
      .filter(
        (ele: any) =>
          String(ele.roleName).toLowerCase() ===
          String(this.selectedRecepint.value).toLowerCase()
      )
      .map((val: any) => {
        this.userDetail = val;
      });
  }

  patchValuesToDescription(invoice: any) {
    console.log(invoice);
    invoice.proformaInvoiceDetailList.map((data: any, index: any) => {
      this.fields.push(
        this.formBuilder.group({
          itemType: new FormControl(data.type),
          itemName: new FormControl(data.name),
          itemDescription: new FormControl(data.itemDescription),
          unitAmount: new FormControl(data.unitAmount),
          quantity: new FormControl(data.quantity),
          totalAmount: new FormControl(Number(data.itemTotalAmount)),
          showInvoiceSave: new FormControl(true),
          showDropDown: new FormControl(false),
          identityId: new FormControl(data.identityId),
          invoiceDetailId: new FormControl(data.id),
          hsnSsc: new FormControl(data.hsnSsc),
        })
      );
    });

    this.itemNotes.setValue(invoice.notes);
    this.subTotal = this.invoice.subTotal;
    this.cPercentage.setValue(invoice.cgstPercentage);
    this.sPercentage.setValue(invoice.sgstPercentage);
    this.dPercentage.setValue(invoice.discountPercentage);
    this.totalCgstAmount = invoice.cgstAmount;
    this.totalSgstAmount = invoice.sgstAmount;
    this.totalDiscountAmount = invoice.discountAmount;
    this.grandSubTotal = invoice.grandTotal;
    this._CommonService.hideLoading();
  }

  getCompanyDetails() {
    this._CommonService.get<any>(urlConstant.Auth.getCompanyDetail).subscribe(
      (res: any) => {
        if (res.Status === "200" && res.data && res.data.CompanyDetail) {
          this.company = res.data.CompanyDetail;
          if (this.company.authExtension) {
            this.companySignature =
              "data:image/" +
              this.company.authExtension.toLowerCase() +
              ";base64," +
              this.company.authBase64;
          }
        } else {
          this.company = null;
        }
        console.log(this.company, "ddd");
      },
      (error) => {
        if (error != null) {
          console.error("error", "Error", error.message);
        }
      }
    );
  }

  getPropertyByPropertyId() {
    this._CommonService
      .get<any>(
        urlConstant.Property.GetPropertyByPropertyId +
          "?propertyId=" +
          this.propertyId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.propertyData = res.data.Property;
        }
      });
  }

  formatIndianNumerationWithDecimals(number: number): string {
    return number !== null && number !== undefined
      ? number.toLocaleString("en-IN", { maximumFractionDigits: 2 })
      : "0";
  }

  showTempLigthBox() {
    const dialogRef = this.dialog.open(ImageShowModalComponent, {
      width: "800px",
      data: {
        attachment: this.invoice.imageList,
        index: 0,
      },
      backdropClass: "custom-backdrop-class", // Custom CSS class for the backdrop
      hasBackdrop: true,
    });

    dialogRef.afterOpened().subscribe(() => {
      const overlay = document.querySelector(".cdk-overlay-backdrop");

      if (overlay) {
        overlay.addEventListener("click", () => {
          dialogRef.close(); // Close the dialog when overlay is clicked
        });
      }
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  getDefaultUser(): string {
    return this.loginUserDetail !== undefined && this.loginUserDetail !== null
      ? String(
          this.loginUserDetail.firstName + " " + this.loginUserDetail.lastName
        )
      : String(
          this.sahredUserDetail.firstName + " " + this.sahredUserDetail.lastName
        );
  }
}
